import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ContactResultModel } from '../models/contactModels';

@Injectable()
export class ContactService {
  private hostPath: string = JSON.parse(environment.IDENTITY);

  constructor(private http: HttpClient) {}

  public contact(
    email: string,
    firstname: string,
    lastname: string,
    phone: string,
    message: string,
    company: string,
    language: string
  ): Observable<ContactResultModel> {
    const data = {
      site: 'www.shuttlebuss.se',
      email,
      firstname,
      lastname,
      phone,
      message,
      company,
      language
    };

    return this.http.post(this.hostPath + 'identity/Contact', data).pipe(
      map((response: any) => {
        const createUserResult = new ContactResultModel();
        const result = response;
        createUserResult.success = result.success;
        return createUserResult;
      }),
      catchError((error: any) => {
        const createUserResult = new ContactResultModel();
        const result = error;
        createUserResult.success = result.success;
        return observableThrowError(createUserResult);
      }),
      finalize(() => {
        //   this._myCommunicationService.loaderChange(false);
      })
    );
  }
}
